import Store from '../Store';

const MarketEmployeesStore = new Store('markets/totals/employees');

export {MarketEmployeesStore};